import { render, staticRenderFns } from "./WhsN.vue?vue&type=template&id=4172fece"
import script from "./WhsN.vue?vue&type=script&lang=js"
export * from "./WhsN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports